// import Image from "../images/sample_01.jpeg";
import AboutImg from "../images/about.jpeg";
//import Image1 from '/assets/kitchen/0006/01.jpg'

const images = {
  base: '/assets/kitchen/0006/web_01.jpg',
  about: AboutImg,
};

const imageSize = {
  tiny: "h-40",
  small: "h-64",
  default: "h-screen",
};

const Highlight = ({ img = "base", size = "default" }) => (
  <div className={`w-screen overflow-hidden flex ${imageSize[size]}`}>
    <img
      src={images[img]}
      alt=""
      className={`object-cover w-screen ${imageSize[size]}`}
    />
  </div>
);

export default Highlight;
